import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { API } from "../global";

export function MovieDetails() {
  const { id } = useParams();
  const history = useHistory();
  // If not valid index push to 404 page
  // const movie = movies[id];

  const [movie, setMovie] = useState({});
  useEffect(() => {
    fetch(`${API}/movies/${id}`, {
      method: "GET",
    }) // returns a promise object
      .then((data) => data.json())
      .then((mv) => setMovie(mv));
  }, []);

  // console.log(movies, movie);
  return (
    <div>
      <iframe
        width="100%"
        height="750"
        src={movie.trailer}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <div className="movie-detail-container">
        <div className="movie-specs">
          <h3 className="movie-name">{movie.name}</h3>
          <p className="movie-rating">⭐ {movie.rating}</p>
        </div>
        <p className="movie-summary">{movie.summary}</p>
        <Button
          onClick={() => history.goBack()}
          variant="contained"
          startIcon={<KeyboardBackspaceIcon />}
        >
          Back
        </Button>
      </div>
    </div>
  );
}
